function toUpperFirst(str) {
  const chars = str.toLocaleLowerCase('tr').match(/./gu);
  chars[0] = chars[0].toLocaleUpperCase('tr');
  return chars.join('');
}

export default toUpperFirst;
